module.exports = __webpack_public_path__ + "img/train3.1836ad24.webp";